import * as React from 'react';
import { Outlet } from 'react-router-dom';
import { Container, CssBaseline } from '@mui/material';
import { SnackbarProvider } from 'notistack';

import ApplicationBar from '../components/ApplicationBar';
import UnsavedChangesDialog from '../components/UnsavedChangesDialog';

import { AppDataProvider } from '../core/context/AppDataContext';
import { GlobalFormStateProvider } from '../core/context/GlobalFormStateContext';
import { GlobalNavigatePromptProvider } from '../core/context/GlobalNavigatePromptContext';

import useIsMobile from '../core/hooks/useIsMobile';

function Layout() {
  const isMobile = useIsMobile();

  return (
    <React.Fragment>
      <CssBaseline />
      <SnackbarProvider anchorOrigin={{ horizontal: 'right', vertical: 'top' }}>
        <AppDataProvider>
          <GlobalFormStateProvider>
            <GlobalNavigatePromptProvider>
              <ApplicationBar />
              <Container maxWidth={false} disableGutters={isMobile} sx={{ mt: 2 }}>
                <Outlet />
              </Container>
              <UnsavedChangesDialog />
            </GlobalNavigatePromptProvider>
          </GlobalFormStateProvider>
        </AppDataProvider>
      </SnackbarProvider>
    </React.Fragment>
  );
}

export default Layout;
